// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".base-chat-item[data-v-64e49892]{background:#fff;border-radius:15px 0 10px 15px;padding:10px}.base-chat-item[data-v-64e49892]:not(:last-child){margin-bottom:5px}.base-chat-item__avatar[data-v-64e49892]{flex-shrink:0;height:20px;margin-right:10px;width:20px}.base-chat-item .base-richtext[data-v-64e49892] img{height:11px;vertical-align:baseline;width:11px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
